import React from 'react';
import { withCookies } from 'react-cookie';
import { DeleteOutlined } from '@ant-design/icons';
import { SearchBar, List, Modal, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import moment from "moment";

import { _getDataFormList, _dropDataForm } from "../../server";

import "./index.css";
import styles from "./formlist.module.css";

const Item = List.Item;
const alert = Modal.alert;

class DraftPage extends React.Component {

    constructor(props) {
        super(props)
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        this.state = { draftForms: [] };
        this.getDraftList();
    }

    async getDraftList() {
        const res = await _getDataFormList(this.sid, -2, 0, 100);
        if (res.code === 0) {
            this.setState({ draftForms: res.data.list, originList: [].concat(res.data.list), });
        }
    }

    async dropDataForm(formDataId) {
        const res = await _dropDataForm(this.sid, formDataId);
        if (res.code === 0) {
            Toast.info('操作成功', 1);
            this.getDraftList();
        } else {
            Toast.offline('网络错误，请稍后重试', 3);
        }
    }

    deleteDataForm = (data) => {
        this.dropDataForm(data);
    }

    render() {
        const view_listForm = this.state.draftForms.map((item, index) =>
            <Link key={index} to={{ pathname: '/formmain', query: { formDataId: item.formDataId } }}>
                <div className={[`${styles.cardListItem}`, `${styles.flexbox}`].join(' ')}>
                    <div className={styles.flexItem}>
                        <div className={styles.listTitle}>
                            <h3>{item.instanceTitle}</h3>
                        </div>
                        <p className={styles.listInfo}>
                            {moment(item.createTime).format('YYYY年MM月DD日 HH:mm:ss')}
                        </p>
                    </div>
                    <div>
                        <DeleteOutlined
                            className={styles.iconOperate}
                            onClick={(e) => {
                                e.preventDefault();
                                alert('删除', '是否要删除该填写草稿',
                                    [
                                        { text: '取消', onPress: () => console.log('cancel') },
                                        { text: '删除', onPress: () => this.deleteDataForm(item.formDataId) },
                                    ])
                            }
                            } />
                    </div>
                </div>
            </Link>
        );
        return <div className="wrap" style={{ overflowY: 'auto' }}>
            <SearchBar placeholder="请输入关键词" maxLength={20} className={styles.my_searchBar}
                onChange={(value) => {
                    if (value) {
                        let tmpArray = [];
                        this.state.draftForms.map((item) => {
                            if (item.instanceTitle.toUpperCase().indexOf(value.toUpperCase()) >= 0) {
                                tmpArray.splice(tmpArray.length, 0, item);
                            }
                        })
                        this.setState({ draftForms: tmpArray });
                    } else {
                        this.setState({ draftForms: this.state.originList });
                    }
                }} />
            <List style={{ marginTop: 45 }}>
                {this.state.draftForms.length > 0 ? view_listForm : <div className="empty"><div className="img"></div><p className="desc">暂无数据</p></div>}
            </List>
            <div className={styles.showMoreList}><p>共{this.state.draftForms.length}张表单</p></div>
        </div>
    }

}

export default withCookies(DraftPage);

